<template>
    <div class="shipment-open-report-totals">
        <div class="shipment-open-report-totals__item">
            <div class="shipment-open-report-totals__label">
                {{ $t('pages.report.openShipmentReport.totalPrice') }}
            </div>
            <div class="shipment-open-report-totals__value">
                {{ formatCurrency(totalPrice) }}
            </div>
        </div>
        <div class="shipment-open-report-totals__item">
            <div class="shipment-open-report-totals__label">
                {{ $t('pages.report.openShipmentReport.totalPaid') }}
            </div>
            <div class="shipment-open-report-totals__value">
                {{ formatCurrency(totalPaid) }}
            </div>
        </div>
        <div class="shipment-open-report-totals__item">
            <div class="shipment-open-report-totals__label">
                {{ $t('pages.report.openShipmentReport.totalOutstandingBalance') }}
            </div>
            <div class="shipment-open-report-totals__value shipment-open-report-totals__value--outstanding">
                {{ formatCurrency(totalOutstandingBalance) }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ShipmentOpenReportTotals',
    props: {
        totalPrice: {
            type: Number,
            default: 0,
        },
        totalPaid: {
            type: Number,
            default: 0,
        },
        totalOutstandingBalance: {
            type: Number,
            default: 0,
        },
    },
    methods: {
        formatCurrency(value) {
            return new Intl.NumberFormat('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)
        },
    },
}
</script>

<style lang="scss" scoped>
.shipment-open-report-totals {
    display: flex;
    gap: 24px;
    margin-bottom: 24px;
    padding: 16px;
    background: #f5f5f5;
    border-radius: 4px;
    flex-wrap: wrap;

    &__item {
        display: flex;
        flex-direction: column;
        gap: 8px;
        min-width: 200px;
    }

    &__label {
        font-size: 14px;
        color: #666;
        font-weight: 500;
    }

    &__value {
        font-size: 20px;
        font-weight: 700;
        color: #333;

        &--outstanding {
            color: #d32f2f;
        }
    }
}
</style>

